<script>
import TableBlock from '@/components/Analysis/TableBlockMixin';
export default {
  mixins: [TableBlock],

  computed: {
    computedData() {
      const { sites, filteredCollaborators } = this.data;
      const computedSites = this.range ? sites.slice(this.range[0], this.range[1]) : sites;
      const decays = this.computeImpact(computedSites, 'decay', true, filteredCollaborators, this.forcedTransport);
      let entries = this.computeImpact(computedSites, 'improvement', false, filteredCollaborators, this.forcedTransport);

      entries = entries.map((item, idx) => {
        return [...item, ...decays[idx]];
      });
      return {
        data: {
          superHeader: [
            {
              type: 'sub-header',
              caption: '',
              className: 'big',
            },
            {
              caption: this.$t('improvement'),
              className: ['super-header', 'underline'],
            },
            {
              type: 'heading',
              caption: '',
            },
            {
              caption: this.$t('degradation'),
              className: ['super-header', 'underline'],
            },
            {
              type: 'heading',
              caption: '',
            },
          ],
          specifications: [
            {
              className: {
                big: true,
              },
            },
            {
              type: 'heading',
              caption: this.$t('collaboratorsNumber'),
            },
            {
              type: 'heading',
              caption: this.$t('averageTimeSaved'),
            },
            {
              type: 'heading',
              caption: this.$t('collaboratorsNumber'),
            },
            {
              type: 'heading',
              caption: this.$t('averageAdditionalTime'),
            },
          ],
          entries,
        },
      };
    },
  },
};
</script>
